<template>
  <div>
    <div
      v-show="resettingpassword==false && !loading && user_id != 0"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-header bg-white border-0">
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </div>
      <div class="card-body">
        <h4>Reset password</h4>
        <form
          autocomplete="off"
          @submit.prevent="resetpassword"
        >
          <div class="mb-3 ps-3 d-flex align-items-center">
            <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Enter your new password</label>
            <div style="width: 58%;">
              <input
                v-model="i_password"
                autocomplete="off"
                type="password"
                class="form-control"
                :class="{'is-invalid': !i_password_valid}"
              />
              <div v-if="!i_password_valid" class="invalid-feedback d-block">
                Password must not be blank and must be the same as the repeat password
              </div>
            </div>
          </div>
          <div class="mb-3 ps-3 d-flex align-items-center">
            <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Repeat your new password</label>
            <div style="width: 58%;">
              <input
                v-model="i_password_repeat"
                autocomplete="off"
                type="password"
                class="form-control"
                :class="{'is-invalid': !i_password_repeat_valid}"
              />
              <div v-if="!i_password_repeat_valid" class="invalid-feedback d-block">
                Repeat password must not be blank and must be the same as the password
              </div>
            </div>
          </div>
          <div v-if="message !== ''" class="alert alert-danger text-start">
            {{ message }}
          </div>
          <div class="col-12 mx-auto text-center">
            <button
              class="btn btn-primary col-6"
              type="submit"
            >
              <span class="icon-key me-2" />Update your password
            </button>
          </div>
        </form>
      </div>
    </div>
    <div
      v-show="resettingpassword==false && !loading && Number(user_id) === 0"
      class="mx-auto col-6 border-0 text-start"
    >
      <div class="alert alert-danger" role="alert">
        The link is incorrect or has expired
      </div>
    </div>
    <div
      v-show="resettingpassword==true && user_id != 0"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-header bg-white border-0">
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </div>
      <div class="card-body">
        <div class="alert alert-success" role="alert">
          Your password has been reset<br><br>
          <button
            class="btn btn-primary col-12 col-sm-6"
            @click.prevent="gotologin"
          >
            <span class="icon-key ms-2 me-2" />Go to login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ResetPassword',
  components: {
  },
  data () {
    return {
      token: this.$route.params.t,
      user_id: 0,
      loading: true,
      i_password: '',
      i_password_valid: true,
      i_password_repeat: '',
      i_password_repeat_valid: true,
      resettingpassword: false,
      passwordhasbeenreset: false,
      message: ''
    }
  },
  mounted () {
    this.getuserid()
  },
  methods: {
    gotologin() {
      this.$router.push('/');
    },
    getuserid () {
      this.$store.dispatch('userbytoken_fetch', { token: this.token })
      .then((resp) => {
        this.user_id = resp.data.i
        this.loading = false
      })
      .catch(() => {
        this.user_id = 0
        this.loading = false
      })
    },
    resetpassword () {
      var formok = true
      if (this.i_password == '') {
        this.i_password_valid = false
        formok = false
      }
      if (this.i_password_repeat == '') {
        this.i_password_repeat_valid = false
        formok = false
      }
      if (this.i_password != this.i_password_repeat) {
        this.i_password_valid = false
        this.i_password_repeat_valid = false
        formok = false
      }
      if (formok) {
        this.savefield('i_user', this.user_id, 'i_password', this.i_password)
      }
    },
    savefield (tablename, id, fieldname, value) {
      if (id > 0) {
        var record = {
          id: id,
          [fieldname]: value,
          token: this.token
        }
        return this.$store.dispatch('resetpassword_save', { user: record })
        .then((resp) => {
          if (resp.data.status === 'OK') {
            this.resettingpassword = true
          } else {
            this.message = resp.data.error || 'The password could not be reset'
          }
        })
        .catch(() => {
          this.message = 'The password could not be reset'
        })
      }
    }
  }
}
</script>
<style>
</style>
